import { MessageKeys, NestedKeyOf, NestedValueOf, useTranslations } from 'next-intl';
import { ReactNode } from 'react';

type MessageKey = MessageKeys<IntlMessages, NestedKeyOf<IntlMessages>>;

type ExtractTemplateVariable<
  T extends string,
  Base extends string = never,
> = T extends `${infer Head}{${infer Variable extends string}}${infer Rest}`
  ? ExtractTemplateVariable<`${Head}${Rest}`, Base | Variable>
  : Base;

type InferMessage<Key extends MessageKey> = ExtractTemplateVariable<NestedValueOf<IntlMessages, Key>>;

type Props<T extends MessageKey> = {
  id: T;
} & (InferMessage<T> extends never
  ? {
      values?: never;
    }
  : {
      values: { [K in InferMessage<T>]: string | number | boolean | Date | null | undefined /* TranslationValues */ };
    });

export const FormattedMessage = <TargetKey extends MessageKey>({ id, values }: Props<TargetKey>): ReactNode => {
  const t = useTranslations();
  return t(id, values);
};
